import { action, computed, flow, makeObservable, observable } from 'mobx'
import Store from './Store'
import Paginator from '../models/Paginator'
import Event from '../models/Event'
import EventService from '../services/EventService'
import Form from '../models/Form'
import FormEntry from '../models/FormEntry'
import FormIndex from '../components/Events/Forms/FormIndex'
// import { openDB } from 'idb'

class EventsStore extends Store {
  /**
   * @type {Event}
   */
  @observable event
  @observable forms = []
  @observable NFPAFormId = 0
  @observable tmpNFPAFormEntries = new Map()

  /**
   * @type {Form}
   */
  @observable currentForm = null
  @observable _showAllEquipment = false
  @observable menuEquipment = {
    type: 'pagination',
    label: 'Équipment No',
    searchFields: []
  }

  /**
   * @type {FormEntry}
   */
  @observable currentEquipment = null
  @observable equipmentIndex = 1
  @observable isDirty = false
  @observable equipmentWithErrors = new Map()
  /**
   * @type {array<Event>}
   */
  @observable events = []
  @observable paging = {}
  @observable _tmpQuery = {}
  @observable isDownloading = false

  @computed
  get equipmentCount () {
    if (!this.event) {
      return 0
    }
    // console.log(this.event.forms_entries.filter(entry => entry.form_id === this.currentForm.id))
    return this.event.forms_entries.filter(entry => entry.form_id === this.currentForm.id).length
  }

  @computed
  get allEquipmentsFromCurrentForm () {
    return this.event.forms_entries.filter(entry => entry.form_id === this.currentForm.id)
  }

  @computed
  get hasNFPA () {
    return !!this.NFPAFormId
  }

  @computed
  get showAllEquipment () {
    return this._showAllEquipment && this.menuEquipment.enableShowAll
  }

  constructor () {
    super()
    makeObservable(this)
    this._tmpQuery = sessionStorage.getItem('eventStore')
      ? JSON.parse(sessionStorage.getItem('eventStore'))
      : {}
    this.sendFilters()
    /*
    const dbName = 'mci'
    const version = 1

    openDB(dbName, version, {
      upgrade (db, oldVersion, newVersion, transaction) {
        db.createObjectStore('events', { keyPath: 'id' })
        db.createObjectStore('forms', { keyPath: 'id' })
        console.log(db, oldVersion, newVersion, transaction)
      }
    }).then(db => {
      console.log(db)
      this.db = db
      console.log(this.db.objectStoreNames)
    }) */
  }

  @action
  initLoading () {
    this.isLoading = true
  }

  @action
  showAllEquipments (showAll = false) {
    this._showAllEquipment = showAll
  }

  @action
  changeMenuType (type, options) {
    switch (type) {
      case 'search':
        this.menuEquipment = {
          type: 'search',
          enableShowAll: options.enableShowAll || false,
          label: options.label || 'Équipment No',
          searchFields: options.searchFields
        }
        break
      case 'pagination':
      default:
        this.menuEquipment = {
          type: 'pagination',
          enableShowAll: options.enableShowAll || false,
          label: 'Équipment No'
        }
        break
    }
  }

  @action
  setEquipmentPage (equipmentIndex) {
    this.equipmentIndex = equipmentIndex
    this.currentEquipment = this.allEquipmentsFromCurrentForm[equipmentIndex - 1]
  }

  @action
  setEquipmentPageByFormEntry (formEntry) {
    this.equipmentIndex = this.allEquipmentsFromCurrentForm.findIndex(_formEntry => _formEntry.id === formEntry.id) + 1
    this.currentEquipment = formEntry
  }

  @flow
  * loadAllArchive () {
    this.isLoading = true
    const result = yield EventService.getArchives(this.query)
    this.paging.Events = new Paginator(result.paginator.Events)
    this.events = []
    for (const event of result.events) {
      this.events.push(new Event(event))
    }
    this.isLoading = false
  }

  @flow
  * loadAll () {
    this.isLoading = true
    const result = yield EventService.getEvents(this.query)
    this.paging.Events = new Paginator(result.paginator.Events)
    this.events = []
    for (const event of result.events) {
      this.events.push(new Event(event))
    }
    this.isLoading = false
  }

  @flow
  * loadOne (eventId) {
    this.isLoading = true
    const result = yield EventService.getEvent(eventId)
    if (result) {
      this.event = new Event(result.event)
    }
    this.isLoading = false
  }

  @flow
  * loadFormArchiveWithJwt (jwt, eventId) {
    this.isLoading = true
    const result = yield EventService.getFormCodesWithJwt(eventId, jwt)
    if (result) {
      this.forms = []
      for (const form of result.forms) {
        const formObj = new Form(form)
        //  yield this.db.put('forms', toJS(formObj))
        this.forms.push(formObj)
      }
      this.event = new Event(result.event, true)
      // console.log(this.db)
      // yield this.db.put('events', toJS(this.event))
      this.changeCurrentForm(this.forms[0].code)
    } else {
      this.addToast('Erreur inconnue', 'error')
    }
    this.isLoading = false
  }

  @flow
  * loadFormArchive (eventId, formCode = null) {
    this.isLoading = true
    const result = yield EventService.getFormCodes(eventId)
    if (result) {
      this.forms = []
      for (const form of result.forms) {
        const formObj = new Form(form)
        //  yield this.db.put('forms', toJS(formObj))
        this.forms.push(formObj)
      }
      this.event = new Event(result.event, true)
      // console.log(this.db)
      // yield this.db.put('events', toJS(this.event))
      this.changeCurrentForm(formCode || this.forms[0].code)
    } else {
      this.addToast('Erreur inconnue', 'error')
    }
    this.isLoading = false
  }

  @flow
  * loadFormEvent (eventId, formCode = null) {
    this.isLoading = true
    const result = yield EventService.getFormCodes(eventId)
    if (result) {
      this.forms = []
      for (const form of result.forms) {
        const formObj = new Form(form)
        //  yield this.db.put('forms', toJS(formObj))
        this.forms.push(formObj)
        if (form.code === 'RI-A-NFPA-000') {
          this.NFPAFormId = form.id
        }
      }
      this.event = new Event(result.event)
      // console.log(this.db)
      // yield this.db.put('events', toJS(this.event))
      this.changeCurrentForm(formCode || this.forms[0].code)
    } else {
      this.addToast('Erreur inconnue', 'error')
    }
    this.isLoading = false
  }

  @flow
  * saveForms () {
    this.isSaving = true
    let i = 1
    for (const form of this.event.forms_entries) {
      this.message = `Enregistrement du formulaire ${i}/${Object.keys(this.event.forms_entries).length}`
      i++
      try {
        const response = yield EventService.saveEventForm(this.event.id, form.toObject())
        if (!response) {
          this.isSaving = false
          this.addToast('Erreur inconnue', 'error')
          return
        }
        if (!response.result.success) {
          console.log(`leaving save with error ${response.result.message}`)
          this.errorMessage = response.result.message
          this.isSaving = false
          return
        }
        form.id = response.result.data.id
        for (const [newId, key] of Object.entries(response.result.data.forms_datas)) {
          form.forms_datas[key].id = newId
        }
      } catch (e) {
        // handle this
        console.log(e)
      }
    }
    this.isSaving = false
  }

  @flow
  * submitEvent () {
    this.isSaving = true
    const response = yield EventService.submitEvent(this.event.id, this.event.toObject())
    this.isSaving = false
    if (!response.success) {
      this.errorMessage = response.message
    }
  }

  @flow
  * completeEvent () {
    this.isSaving = true
    const response = yield EventService.completeEvent(this.event.id)
    this.isSaving = false
    this.addToast(response.result.message, response.result.success ? 'success' : 'error')
    return response.result
  }

  @flow
  * rejectEvent () {
    this.isSaving = true
    const response = yield EventService.rejectEvent(this.event.id)
    this.isSaving = false
    this.addToast(response.result.message, response.result.success ? 'success' : 'error')
    return response.result
  }

  /**
   *
   * @param {boolean} [validateOnly=false]
   */
  @action
  validateForms (validateOnly = false) {
    this.equipmentWithErrors = new Map()
    let changePageToThisFromEntry = null
    for (const form of this.forms) {
      const formEntries = this.event.forms_entries.filter(formEntry => formEntry.form_id === form.id)
      const Form = FormIndex[form.code.replaceAll('-', '')]
      if (Form.fieldsRequired === undefined && Form.dynamicFieldsRequired === undefined) {
        for (const formEntry of formEntries) {
          formEntry.is_valid = true
        }
        continue
      }

      for (const formEntry of formEntries) {
        // check for static fields
        if (Form.fieldsRequired) {
          for (const fieldRequired of Form.fieldsRequired) {
            if (formEntry.forms_datas[fieldRequired.section] && formEntry.forms_datas[fieldRequired.section].value) {
              console.log(`Section ${fieldRequired.section} hidden`)
              continue
            }
            for (const field of fieldRequired.fields) {
              if (formEntry.forms_datas[field] === undefined || !formEntry.forms_datas[field].value) {
                formEntry.setError(field, 'Ce champs est requis!')
                // console.log(form.code, field)
                if (!this.equipmentWithErrors.has(formEntry.id)) {
                  this.equipmentWithErrors.set(formEntry.id, formEntry)
                  if (!changePageToThisFromEntry && formEntry.form_id === this.currentForm.id) {
                    changePageToThisFromEntry = formEntry
                  }
                }
              }
            }
          }
        }

        // check for dynamic fields
        if (Form.dynamicFieldsRequired) {
          for (const fieldRequired of Form.dynamicFieldsRequired) {
            if (formEntry.forms_datas[fieldRequired.section] && formEntry.forms_datas[fieldRequired.section].value) {
              console.log(`Section ${fieldRequired.section} hidden`)
              continue
            }
            if (formEntry.forms_datas[fieldRequired.name] === undefined) {
              console.log(`Section ${fieldRequired.section} have no iteration`)
              continue
            }
            const totalIteration = parseInt(formEntry.forms_datas[fieldRequired.name].value)
            if (!totalIteration) {
              continue
            }
            for (const index of [...Array(totalIteration)]) {
              for (const field of fieldRequired.fields) {
                if (formEntry.forms_datas[`${field}${index}`] === undefined) {
                  console.log(form.code, field)
                  formEntry.setError(`${field}${index}`, 'Ce champs est requis!')
                  if (!this.equipmentWithErrors.has(formEntry.id)) {
                    this.equipmentWithErrors.set(formEntry.id, formEntry)
                    if (!changePageToThisFromEntry && formEntry.form_id === this.currentForm.id) {
                      changePageToThisFromEntry = formEntry
                    }
                  }
                }
              }
            }
          }
        }
        if (!this.equipmentWithErrors.has(formEntry.id)) {
          formEntry.is_valid = true
        }
      }
    }
    if (validateOnly) {
      if (this.equipmentWithErrors.size) {
        this.addToast('Erreurs trouvées', 'error')
      } else {
        this.addToast('Formulaire valide', 'success')
      }
    }
    if (changePageToThisFromEntry) {
      this.setEquipmentPageByFormEntry(changePageToThisFromEntry)
    }
  }

  @action
  addNFPA (formEntryId, label, key, value = '') {
    if (!this.hasNFPA) {
      console.log('no NFPA')
      return
    }
    // find current form
    const sourceFormEntry = this.event.forms_entries.find(formEntry => formEntry.id === formEntryId)
    sourceFormEntry.generateUUID()
    const internalData = `${sourceFormEntry.uuid}_${key}`
    // check if already exist
    for (const formEntry of this.event.forms_entries) {
      if (formEntry.form_id !== this.NFPAFormId) {
        continue
      }
      if (internalData === formEntry.internal_data) {
        // NFPA form already exist
        console.log('NFPA already exists.')
        return
      }
    }
    const newFormEntry = new FormEntry({
      internal_data: internalData,
      clients_addresses_equipment_id: this.event.clients_addresses_equipment_id,
      event_id: this.event.id,
      form_id: this.NFPAFormId,
      forms_datas: [
        { key: 'section', value: this.currentForm.name },
        { key: 'alinea', value: label },
        // num System is a custom request
        { key: 'numSystem', value: this.currentEquipment.getValue('numSysteme') ? this.currentEquipment.getValue('numSysteme') : this.equipmentIndex },
        { key: 'note', value }
      ]
    })
    this.tmpNFPAFormEntries.set(internalData, newFormEntry)
    this.event.forms_entries.push(newFormEntry)
  }

  @action
  removeNFPA (formEntryId, key) {
    if (!this.hasNFPA) {
      return
    }
    const sourceFormEntry = this.event.forms_entries.find(formEntry => formEntry.id === formEntryId)
    const internalData = `${sourceFormEntry.uuid}_${key}`
    if (this.tmpNFPAFormEntries.has(internalData)) {
      this.tmpNFPAFormEntries.delete(internalData)
      this.event.forms_entries = this.event.forms_entries.filter(formEntry => formEntry.internal_data !== internalData)
    }
  }

  @action
  generateNFPA () {
    // check if we have nfpa form in the event
    const nfpaFormId = this.forms.find(form => form.code === 'RI-A-NFPA-000')
    if (!nfpaFormId) {
      return
    }

    // first get previous nfpa internal forms
    const previousFormEntry = []
    for (const formEntry of this.event.forms_entries) {
      if (formEntry.form_id === nfpaFormId && formEntry.internal_data) {
        previousFormEntry.push(formEntry)
      }
    }
  }

  @action
  changeCurrentForm (code) {
    if (this.currentForm?.code === code) {
      return
    }
    if (code === 'summary') {
      this.currentForm = new Form({ code: 'Summary' })
      this.menuEquipment = {}
      return
    }

    for (const form of this.forms) {
      if (form.code === code) {
        this.currentForm = form
        if (!this.equipmentCount) {
          if (this.event.readonly) {
            this.menuEquipment = {}
            return
          }
          this.createEquipment()
        }
        let hasCurrentFormError = false
        for (const formEntry of this.equipmentWithErrors.values()) {
          if (formEntry.form_id === form.id) {
            hasCurrentFormError = true
            this.setEquipmentPageByFormEntry(formEntry)
            break
          }
        }
        if (!hasCurrentFormError) {
          this.setEquipmentPage(1)
        }
        this.menuEquipment = {
          type: 'pagination',
          label: 'Équipment No'
        }
        return
      }
    }
  }

  /**
   * @param userId
   * @param clientId
   * @param clientAddressEquipmentId
   * @param start
   * @param end
   */
  @flow
  * createInspectionEvent (userId, clientId, clientAddressEquipmentId, start, end) {
    this.isSaving = true
    const response = yield EventService.create(clientId, clientAddressEquipmentId, {
      user_id: userId,
      start,
      end
    })
    this.isSaving = false
    if (!response.result.success) {
      this.errorMessage = response.result.message
      throw new Error(response.result.message)
    }
  }

  @flow
  * editInspectionEvent (eventId, userId, start, end) {
    this.isSaving = true
    const response = yield EventService.editEvent(eventId, {
      user_id: userId,
      start,
      end
    })
    this.isSaving = false
    if (!response.result.success) {
      this.errorMessage = response.result.message
      throw new Error(response.result.message)
    }
  }

  @action
  changePage (newPage) {
    if (newPage <= this.paging.Events.pageCount && newPage > 0) {
      this.paging.Events.page = newPage
      this.query.page = newPage
    }
  }

  @action
  sendFilters () {
    for (const [key, value] of Object.entries(this._tmpQuery)) {
      this.query[key] = value
    }
    this.query.page = 1
    sessionStorage.setItem('eventStore', JSON.stringify(this._tmpQuery))
    this.events = []
  }

  @action
  clearFilters () {
    this._tmpQuery = {}
    this.query = {}
    this.events = []
    sessionStorage.removeItem('eventStore')
  }

  @action
  createEquipment (formId) {
    this.event.forms_entries.push(new FormEntry({
      clients_addresses_equipment_id: this.event.clients_addresses_equipment_id,
      event_id: this.event.id,
      form_id: formId || this.currentForm.id
    }))
  }

  @flow
  * download (eventId) {
    if (this.isDownloading) {
      return
    }
    this.isDownloading = true
    const pendingToast = this.addToast('Génération du rapport en cours...', '', 120000)
    try {
      const result = yield EventService.getDownloadToken(eventId)
      if (!result || !result.jwt) {
        throw new Error('Jeton de téléchargement indisponible')
      }
      yield this.downloadFile(`/_pdf/?jwt=${result.jwt}`, 'rapport.pdf')
      this.addToast('Rapport téléchargé', 'success')
    } catch (e) {
      console.error(e)
      this.addToast('Impossible de télécharger le rapport. Veuillez réessayer', 'error')
    }
    this.removeToast(pendingToast)
    this.isDownloading = false
  }

  /**
   *
   * @param {FormEntry} equipment
   * @returns {Generator<*, void, *>}
   */
  @flow
  * deleteEquipment (equipment) {
    const changeCurrentEquipment = equipment === this.currentEquipment
    if (equipment === this.currentEquipment) {
      this.isLoading = true
    }
    this.event.forms_entries = this.event.forms_entries.filter(formEntry => formEntry !== equipment)
    if (!equipment.id) {
      if (changeCurrentEquipment) {
        this.setEquipmentPage(this.equipmentIndex ? (this.equipmentIndex - 1) : 0)
      }
      this.isLoading = false
      return true
    }
    let response
    try {
      response = yield EventService.deleteEquipment(equipment.id)
      if (response.result.success) {
        if (changeCurrentEquipment) {
          this.setEquipmentPage(this.equipmentIndex ? (this.equipmentIndex - 1) : 0)
        }
        this.isLoading = false
        return true
      }
    } catch (e) {
      this.isLoading = false
      this.addToast("Impossible de supprimer l'équipement", 'error')
    }
  }

  @flow
  * importLastEvent (eventId, formCode) {
    if (!formCode) {
      throw new Error('Vous êtes pas dans un formulaire')
    }
    this.isLoading = true
    const response = yield EventService.reset(eventId, formCode)
    this.isLoading = false
    if (!response.result.success) {
      throw new Error(response.result.message)
    }
    this.addToast('Inspection importée', 'success')
  }

  @flow
  * confirmEvent (eventId) {
    const response = yield EventService.confirmEvent(eventId)
    if (!response.result.success) {
      throw new Error(response.result.message)
    }
    this.addToast('Inspection confirmé', 'success')
  }

  @flow
  * deleteEvent (eventId) {
    let response
    try {
      response = yield EventService.deleteEvent(eventId)
    } catch (e) {
      this.addToast("Impossible de supprimer l'inspection", 'error')
      throw e
    }
    if (response.result.success) {
      this.addToast("L'inspection à été supprimé", 'success', 10000)
    } else {
      this.addToast(response.result.message, 'error')
      throw new Error(response.result.message)
    }
  }
}

export default EventsStore
